/* eslint-disable import/prefer-default-export */
export const GET_REGULAR_SERVICES = 'GET_REGULAR_SERVICES';
